import { useEffect, useRef, useState } from "react";
import axios from "../lib/axiosInstance";

/**
 * Reads a social signup ticket off the URL and asks the backend what the provider
 * told us about this person.
 *
 * The ticket is a JWT, but we deliberately don't decode it here: the server is the
 * only thing that should read tokens, and asking it means an expired ticket surfaces
 * on page load rather than after someone has filled in the whole form.
 */
export default function useSignupTicket() {
  // Captured once, so later renders can't lose it if the query string changes.
  const ticketRef = useRef(null);
  if (ticketRef.current === null) {
    ticketRef.current = new URLSearchParams(window.location.search).get("ticket") || false;
  }
  const ticket = ticketRef.current;

  const [prefill, setPrefill] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!ticket) return;

    axios
      .get(`auth/signupTicket?ticket=${encodeURIComponent(ticket)}`)
      .then((res) => setPrefill(res.data?.data ?? null))
      .catch(() => setIsExpired(true));
  }, [ticket]);

  return { ticket, prefill, isExpired, isSocial: Boolean(ticket) };
}
